<template>
  <div class="screen-container" @click="hideHonor">
    <header class="screen-header">
      <div class="title">盐城区域级产能共享工业互联网平台</div>
      <div class="title2">国家中小企业公共服务示范平台 &nbsp;&nbsp;&nbsp; 国家级服务型制造示范平台</div>
    </header>
    <div class="screen-body">
      <!-- 左侧 -->
      <section class="screen-left">
        <div id="left-top" style="height: 18.5%">
          <div class="box">
            <div class="box-head">
              <div class="box-title">
                <img src="/static/img/jt.png" />
                <div>共享产能</div>
              </div>
              <div class="box-line-1"></div>
              <div class="box-line-2"></div>
              <div class="box-line-3"></div>
              <div class="box-line-4"></div>
            </div>
            <div class="box-body">
              <div class="left-top">
                <div class="left-top-item" v-for="(item, index) in leftTopData" :key="index">
                  <div class="line-1">{{ item.name }}</div>
                  <div class="statistic">
                    <div style="margin-bottom: 5px;">
                      <span>{{ item.value }}</span>
                      <span style="font-size: 12px; margin-left: 7px;margin-top:5px">{{ item.desc }}</span>
                    </div>
                    <div class="last">
                      <div>
                        +{{ item.last }}
                      </div>
                      <div>上月</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="left-middle" style="height: 21%">
          <div class="box">
            <div class="box-head">
              <div class="box-title">
                <img src="/static/img/jt.png" />
                <div>平台企业分布</div>
              </div>
              <div class="box-line-1"></div>
              <div class="box-line-2"></div>
              <div class="box-line-3"></div>
              <div class="box-line-4"></div>
            </div>
            <div class="box-body">
              <cmp-left-middle-two></cmp-left-middle-two>
            </div>
          </div>
        </div>
        <div id="right-top" style="height: 19%">
          <div class="box">
            <div class="box-head">
              <div class="box-title">
                <img src="/static/img/jt.png" />
                <div>供需对接</div>
              </div>
              <div class="box-line-1"></div>
              <div class="box-line-2"></div>
              <div class="box-line-3"></div>
              <div class="box-line-4"></div>
            </div>
            <ul style="display: flex;">
              <li class="statistic_item_demand mul_line item_name">
                {{ '需求名称' }}
              </li>
              <li class="statistic_item_demand mul_line item_name">
                {{ '工艺' }}
              </li>
              <li class="statistic_item_demand mul_line item_num">
                {{ '采购数量' }}
              </li>
              <!-- <li class="statistic_item_demand mul_line item_area">
                {{ '需求来源' }}
              </li> -->
              <li class="statistic_item_demand mul_line item_time">
                {{ '截止日期' }}
              </li>
            </ul>
            <vue-seamless-scroll :data="demandLinkList" class="seamless-warp" :class-option="classOptionLeft">
              <ul v-for="(item, index) in demandLinkList" style="display:flex;" :key="index" @click="viewInqury">
                <li class="statistic_item_demand mul_line item_name" :class="index % 2 == 1 ? '' : 'statistic-item-bg'">
                  {{ item.name }}
                </li>
                <li class="statistic_item_demand mul_line item_name" :class="index % 2 == 1 ? '' : 'statistic-item-bg'">
                  {{ item.craftAndMaterial }}
                </li>
                <li class="statistic_item_demand mul_line item_num" :class="index % 2 == 1 ? '' : 'statistic-item-bg'">
                  {{ item.quantity }}
                </li>

                <li class="statistic_item_demand mul_line item_time" :class="index % 2 == 1 ? '' : 'statistic-item-bg'">
                  {{ item.offerEndDate ? item.offerEndDate.substr(0, 10) : '' }}
                </li>
              </ul>
            </vue-seamless-scroll>
          </div>
          <!-- <cmp-left-bottom-two></cmp-left-bottom-two> -->
        </div>
        <div id="left-middle" style="height: 25.5%">
          <div class="box">
            <div class="box-head">
              <div class="box-title">
                <img src="/static/img/jt.png" />
                <div>明星订单</div>
              </div>
              <div class="box-line-1"></div>
              <div class="box-line-2"></div>
              <div class="box-line-3"></div>
              <div class="box-line-4"></div>
            </div>
            <div class="box-body">
              <!-- <cmp-left-mid-two></cmp-left-mid-two> -->
              <leftSwiper></leftSwiper>
            </div>
          </div>
        </div>
      </section>
      <section class="screen-middle">
        <div id="middle-top" style="height: 14%">
          <div style="
              height: 20%;
              display: flex;
              justify-content: space-between;
              flex-wrap: wrap;
              position: relative;
              z-index: 100;
            ">
            <div v-for="(item, index) in downApp" :key="index" :style="index % 2 == 0
              ? 'width: 48%; text-align: left; margin-top: 0.625rem;margin-left:0.665rem;'
              : 'width: 48%; text-align: right; margin-top: 0.625rem;margin-right:0.645rem;'
              ">
              <div :style="index % 2 != 0
                ? index == 3
                  ? 'padding-right:42px'
                  : 'padding-right:130px'
                : ''
                ">
                {{ item.name }}
                <router-link to="/screenpage" v-if="index == 3" style="
                    color: #09def1;
                    font-size: 0.625rem;
                    text-decoration: none;
                  ">>进入连接设备
                </router-link>
              </div>
              <div :class="index % 2 == 0 ? 'bg2' : 'bg2_2'" :style="index % 2 == 0
                ? 'height: 63px;display: flex;justify-content: flex-start;margin-top: 0.625rem;'
                : 'height: 63px;display: flex;justify-content: flex-end;margin-top: 0.625rem;'
                ">
                <div class="box1" style="
                    font-weight: bold;
                    font-size: 1.25rem;
                    font-family: TXZT;
                  " v-for="(item1, index1) in item.value" :key="index1">
                  {{ item1 }}
                </div>
                <div style="
                    margin-left: 0.3125rem;
                    font-size: 1rem;
                    line-height: 4.4rem;
                    font-family: TXZT;
                    color: #75e6fe;
                  ">
                  {{ item.unit }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="height: 55%; margin-top: -12%" id="middle-top2">
          <cmp-middle-two></cmp-middle-two>
        </div>
        <!-- <div id="middle-bottom" style="height: 22%; margin-top: -2px">
          <div>
            <div
              class="gaizi"
              style="
                text-align: center;
                color: #00edff;
                font-size: 1.25rem;
                height: 2.5rem;
                line-height: 2.5rem;
              "
            >
              区县排名 TOP5
            </div>
            <table
              style="text-align: center; width: 100%"
              border="0"
              cellspacing="0"
              cellpadding="0"
            >
              <thead>
                <tr>
                  <td>排名</td>
                  <td v-for="(item, index) in tableData.theader" :key="index">
                    <div
                      :style="{
                        'background-color': tableData.colors[index].bg,
                        color: tableData.colors[index].color,
                      }"
                      style="font-size: 0.75rem"
                    >
                      {{ item.name }}
                    </div>
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in tableData.data" :key="index">
                  <td v-if="index == 0">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                    >
                      <path fill="none" d="M0 0h24v24H0z" />
                      <path
                        d="M3.492 8.065L4.778 19h14.444l1.286-10.935-4.01 2.673L12 4.441l-4.498 6.297-4.01-2.673zM2.801 5.2L7 8l4.186-5.86a1 1 0 0 1 1.628 0L17 8l4.2-2.8a1 1 0 0 1 1.547.95l-1.643 13.967a1 1 0 0 1-.993.883H3.889a1 1 0 0 1-.993-.883L1.253 6.149A1 1 0 0 1 2.8 5.2zM12 15a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"
                        fill="rgba(255,215,0,1)"
                      />
                    </svg>
                  </td>
                  <td v-else-if="index == 1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                    >
                      <path fill="none" d="M0 0h24v24H0z" />
                      <path
                        d="M3.492 8.065L4.778 19h14.444l1.286-10.935-4.01 2.673L12 4.441l-4.498 6.297-4.01-2.673zM2.801 5.2L7 8l4.186-5.86a1 1 0 0 1 1.628 0L17 8l4.2-2.8a1 1 0 0 1 1.547.95l-1.643 13.967a1 1 0 0 1-.993.883H3.889a1 1 0 0 1-.993-.883L1.253 6.149A1 1 0 0 1 2.8 5.2zM12 15a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"
                        fill="rgba(192,192,192,1)"
                      />
                    </svg>
                  </td>
                  <td v-else-if="index == 2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                    >
                      <path fill="none" d="M0 0h24v24H0z" />
                      <path
                        d="M3.492 8.065L4.778 19h14.444l1.286-10.935-4.01 2.673L12 4.441l-4.498 6.297-4.01-2.673zM2.801 5.2L7 8l4.186-5.86a1 1 0 0 1 1.628 0L17 8l4.2-2.8a1 1 0 0 1 1.547.95l-1.643 13.967a1 1 0 0 1-.993.883H3.889a1 1 0 0 1-.993-.883L1.253 6.149A1 1 0 0 1 2.8 5.2zM12 15a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"
                        fill="rgba(191,173,111,1)"
                      />
                    </svg>
                  </td>
                  <td v-else>NO.{{ index + 1 }}</td>
                  <td>{{ item.pingtai }}</td>
                  <td>{{ item.biaogan }}</td>
                  <td>{{ item.gongchang }}</td>
                  <td>{{ item.chejian }}</td>
                  <td>{{ item.shangyun }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div> -->
        <div id="middle-bottom" style="height: 22%; margin-top: 18px">
          <div>
            <div class="gaizi" style="
                text-align: center;
                color: #00edff;
                font-size: 1.25rem;
                height: 2.5rem;
                line-height: 2.5rem;
              ">
              {{ year }}智数学苑公开课表
            </div>
            <div class="plan-wrap">
              <div class="plan-item" v-for="(v, idx) in planList" :key="idx">
                <div style="color: rgb(0, 237, 255);white-space: pre-wrap;text-align:center">
                  {{ v.name }}
                </div>
                <div style="font-size: 16px; opacity: 0.7;text-align:center">
                  <span>{{ v.date }}</span>
                  <span style="margin: 0 5px">{{ v.time }}</span>
                  <span>{{ v.period }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="screen-right">
        <!-- <div id="right-top" style="height: 26%">
          <div class="box">
            <div class="box-head">
              <div class="box-title">
                <img src="/static/img/jt.png" />
                <div>数字化水平</div>
              </div>
              <div class="box-line-1"></div>
              <div class="box-line-2"></div>
              <div class="box-line-3"></div>
              <div class="box-line-4"></div>
            </div>
            <div class="box-body">
              <cmp-right-top-two></cmp-right-top-two>
            </div>
          </div>
        </div> -->
        <div id="right-middle">
          <div class="box">
            <div class="box-head">
              <div class="box-title">
                <img src="/static/img/jt.png" />
                <div>数字化服务成果</div>
              </div>
              <div class="box-line-1"></div>
              <div class="box-line-2"></div>
              <div class="box-line-3"></div>
              <div class="box-line-4"></div>
            </div>
            <div class="box-body">
              <div style="
                  display: flex;
                  flex-wrap: wrap;
                  align-items: center;
                  height: 100%;
                  padding-left: 0.625rem;
                ">
                <div style="
                    width: 50%;
                    height: 33%;
                    display: flex;
                    align-items: center;
                  " v-for="(item, index) in rightMiddleData" :key="index">
                  <el-image style="width: 4.0625rem" :src="item.img"></el-image>
                  <div>
                    <div style="font-size: 0.8125rem">{{ item.name }}</div>
                    <div style="margin-top: 3px">
                      <span style="
                          color: #0ad1c9;
                          font-weight: bold;
                          font-size: 1.125rem;
                          font-family: TXZT;
                        ">{{ item.num }}</span>
                      <span style="
                          margin-left: 0.625rem;
                          font-size: 0.9rem;
                          color: #fa0;
                          font-family: TXZT;
                        ">{{ item.desc }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="right-bottom" style="height: 31%">
          <div class="box">
            <div class="box-head">
              <div class="box-title">
                <img src="/static/img/jt.png" />
                <div>智数学苑</div>
              </div>
              <div class="box-line-1"></div>
              <div class="box-line-2"></div>
              <div class="box-line-3"></div>
              <div class="box-line-4"></div>
            </div>
            <div class="box-body">
              <div style="
                  height: 20%;
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                  justify-content: center;
                ">
                <div style="color: #20a0ea; font-size: 1rem">参训人次</div>
                <div class="bg3" v-for="(item, index) in '16041'" :key="index" style="
                    color: #30fdff;
                    padding: 0.1rem 0.3125rem;
                    margin-left: 1rem;
                    font-size: 1.5rem;
                    font-family: TXZT;
                  ">
                  {{ item, }}
                </div>
              </div>
              <div style="
                  display: flex;
                  flex-wrap: wrap;
                  align-items: center;
                  height: 80%;
                  padding-left: 0.625rem;
                  padding-top: 0.325rem;
                  <!-- transform:scale(0.9); -->
                ">
                <div style="
                    width: 25%;
                    height: 40%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: relative;
                  " v-for="(item, index) in rightBottomData" :key="index">
                  <el-image style="width: 4.0625rem" :src="item.img"></el-image>
                  <div style="
                      position: absolute;
                      top: -1.3125rem;
                      display: flex;
                      flex-direction: column;
                      align-items: center;
                      font-size: 1.6rem;
                      color: #23fffc;
                      font-family: TXZT;
                    ">
                    {{ item.num }}
                  </div>
                  <div style="
                      position: absolute;
                      top: 0.9375rem;
                      font-size: 0.625rem;
                    ">
                    <span>{{ item.name }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="right-top" style="height: 30%">
          <div class="box">
            <div class="box-head">
              <div class="box-title">
                <img src="/static/img/jt.png" />
                <div class="honor-box" @click.stop="viewHonor">“智改数转网联”推进动态</div>
              </div>
              <div class="box-line-1"></div>
              <div class="box-line-2"></div>
              <div class="box-line-3"></div>
              <div class="box-line-4"></div>
            </div>
            <!-- <vue-seamless-scroll :data="CardPartsStatisticsList" class="seamless-warp" :class-option="classOption">
              <ul>
                <li class="statistic-item" v-for="(item, index) in CardPartsStatisticsList" :key="index"
                  :class="index % 2 == 1 ? '' : 'statistic-item-bg'">
                  {{ item }}
                </li>
              </ul>
            </vue-seamless-scroll> -->
            <rightSwiper></rightSwiper>
          </div>
        </div>
      </section>
    </div>
    <honorBox ref="honorBox"></honorBox>
  </div>
  <!-- 楼下大屏 -->
</template>
<script>
import axios from 'axios'
import cmpLeftMiddleTwo from '@/components/cmp-left-middle-two.vue'
import cmpLeftMidTwo from '@/components/cmp-left-mid-two.vue'
import cmpLeftBottomTwo from '@/components/cmp-left-bottom-two.vue'
import cmpLeftBottom from '@/components/cmp-left-bottom.vue'
import cmpMiddleTwo from '@/components/cmp-middle-two.vue'
import honorBox from '@/components/honor-box.vue'
import cmpRightTopTwo from '@/components/cmp-right-top-two.vue'
import vueSeamlessScroll from 'vue-seamless-scroll'
import dayjs from 'dayjs'
import leftSwiper from '@/components/left-swiper.vue'
import rightSwiper from '@/components/right-swiper.vue'

export default {
  components: {
    cmpLeftMiddleTwo,
    cmpLeftMidTwo,
    cmpLeftBottomTwo,
    cmpLeftBottom,
    honorBox,
    cmpMiddleTwo,
    cmpRightTopTwo,
    vueSeamlessScroll,
    leftSwiper,
    rightSwiper
  },
  computed: {
    classOption () {
      return {
        step: 0.4, // 数值越大速度滚动越快
        limitMoveNum: 8, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    },
    classOptionLeft () {
      return {
        step: 0.4, // 数值越大速度滚动越快
        limitMoveNum: this.demandLinkList.length, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    }
  },
  data () {
    return {
      year: dayjs().format('YYYY'),
      honorImgs: [],
      honorShow: false,
      planList: [
        {
          name: '企业生产经营管理公开课',
          date: '',
          time: '12期'
          // period: "每月开课",
        },
        {
          name: '精益生产沙盘模拟 ', // 灯塔工厂&智能制造标杆游学
          date: '',
          time: '4期'
          // period: "每季度开课",
        },
        {
          name: '智能制造专家讲座',
          date: '',
          time: '4期'
          // period: "每季度开课",
        },
        {
          name: '工业机器人集成应用实训',
          date: '',
          time: '16期'
          // period: "每季度开课",
        },
        {
          name: 'PLC电气工程师项目实训',
          date: '',
          time: '12期'
          // period: "每月开课",
        },
        {
          name: '网络安全管理员实操演练 ', // 灯塔工厂&智能制造标杆游学
          date: '',
          time: '6期'
          // period: "每季度开课",
        },
        {
          name: '数字化工厂标杆游学',
          date: '',
          time: '8期'
          // period: "每季度开课",
        },
        {
          name: '职业技能等级提升公益班',
          date: '',
          time: '12期'
          // period: "每季度开课",
        }
      ],
      downApp: [],
      banner: [],
      CardPartsStatisticsList: [
        '为市工信局建设“智改数转”线上评测系统，支撑完成全市3000多家企业线上评测',
        '为市工信局建设盐城市“智改数转”综合服务平台',
        '支持建湖、响水、盐都、射阳、大丰、盐南、阜宁、亭湖、等工信部门召开“智改数转”推进会',
        '为市工信局“2022智能制造能力提升县区行”提供全程技术支撑',
        '累计服务天合国能等10家企业获批“省智能工厂”',
        '累计为盐城206家企业提供星级上云服务',
        '服务500多家企业的“智改数转”诊断，28家实施数字化改造',
        '荣获“国家级中小企业公共服务示范平台”',
        '荣获“国家级服务型制造示范平台”',
        '荣获“江苏制造突出贡献奖”',
        '荣获“江苏省智能制造领军服务机构”',
        '荣获“江苏省大数据产业发展试点示范项目”',
        '荣获“省级生产性服务业优秀服务机构和优秀服务方案”等称号',
        '入选全国信息技术标准化技术委员会融合技术和应用标准工作组',
        '入选盐城、泰州、淮安、扬州、宿迁等7地市的“智改数转”服务商资源池'
      ],
      demandLinkList: [
      ],
      tableData: {
        colors: [],
        theader: [],
        data: []
      },

      leftTopData: [],
      rightMiddleData: [],
      rightBottomData: []
    }
  },
  mounted () { },
  created () {
    this.getBannerData()
    this.getTableData()
    this.getDemandData()
    this.getRightMiddle()
    this.getRightBottom()
    this.getLeftTop()
    this.getHonor()
  },
  methods: {
    async getLeftTop () {
      const { data: ret } = await axios.get('/left-top-two')
      this.leftTopData = ret.data
    },
    viewInqury () {
      window.open('https://www.515ugx.com/inquiry')
    },
    async getRightMiddle () {
      const { data: ret } = await axios.get('/right-middle-two')
      this.rightMiddleData = ret.data
    },

    async getRightBottom () {
      const { data: ret } = await axios.get('/right-bottom-two')
      this.rightBottomData = ret.data
    },

    async getBannerData () {
      const { data: ret } = await axios.get('/middle-top-two')
      this.downApp = ret.data
    },
    async getHonor () {
      const { data: ret } = await axios.get('/right-bottom-honor')
      this.honorImgs = ret.banner
    },

    async getTableData () {
      const { data: ret } = await axios.get('/middle-bottom-two')
      //  this.tableHeader = ret.theader
      // this.tableData = ret.data;
      this.tableData.theader = ret.theader
      this.tableData.data = ret.data
      this.tableData.colors = ret.colors
      // this.demandLinkList = ret.demandLinkList
    },
    async getDemandData () {
      const now = new dayjs().format('YYYY-MM-DD 00:00:00')
      const { data: ret } = await axios.get(`https://www.515ugx.com/cos/order/list?current=1&size=100&offerEndDateForStart=${now}`)
      console.log(ret)
      if (ret.data.records) {
        ret.data.records = ret.data.records.filter(item => {
          if (new Date(item.offerEndDate.replace(/-/g, '/')).valueOf() >= new Date().valueOf()) { return item }
        })
      }
      this.demandLinkList = ret.data.records
    },
    viewHonor () {
      this.honorShow = true
      this.$refs.honorBox.init(this.honorImgs)
    },
    hideHonor () {
      if (this.honorShow) {
        this.$refs.honorBox.hide()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.plan-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  .plan-item {
    width: 22%;
    height: 80px;
    margin-top: 25px;
    border: 1px solid rgb(0, 252, 208);
    box-shadow: 0px 0px 20px rgba(0, 252, 208, 0.5) inset;
    border-radius: 2px;
    font-size: 16px;
    padding: 13px 10px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}

.seamless-warp {
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
  height: 100%;
  overflow: hidden;
}

ul,
li {
  padding: 0;
  margin: 0;
}

.statistic-item {
  padding: 8px 20px 8px 40px;
  list-style: none;
  // color: rgb(48, 253, 255);
  color: rgb(255, 255, 255);
  font-size: 14px;
  background-color: rgba(10, 209, 201, 0.1);
}

.statistic_item_demand {
  padding: 8px 0 8px 0;
  list-style: none;
  // color: rgb(48, 253, 255);
  color: rgb(255, 255, 255);
  font-size: 14px;
  background-color: rgba(10, 209, 201, 0.1);
}

.mul_line {
  // display: -webkit-box; //将对象作为弹性伸缩盒子模型显示
  // -webkit-box-orient: vertical; //设置伸缩盒子对象的子元素的排列方式
  // -webkit-line-clamp: 1; //用来限制在一个块元素显示的文本的行数
  overflow: hidden; //超出部分隐藏
  text-overflow: ellipsis; // 不完全显示的末尾加上省略号
  white-space: nowrap; //兼容数字或英文不换行问题
}

.item_name {
  width: 40%;
  text-align: center;
}

.item_num {
  width: 15%;
  text-align: center;
}

.item_area {
  width: 20%;
  text-align: center;
}

.item_time {
  width: 25%;
  text-align: center;
}

.statistic-item-bg {
  background-color: rgba(0, 52, 93, 0);
}

.bg3 {
  background: url(/static/img/szbb@3x.png);
  background-repeat: no-repeat;
  background-position: center top;
  background-size: cover;
}

.gaizi {
  background: url(/static/img/gaizi@3x.png);
  background-repeat: no-repeat;
  background-position: center top;
  background-size: 120% 2.925rem;
}

.bg2 {
  background: url(/static/img/gx@3x.png);
  background-repeat: no-repeat;
  background-position: left bottom;
  background-size: 11.75rem 2.25rem;
}

.bg2_2 {
  background: url(/static/img/gx@3x.png);
  background-repeat: no-repeat;
  background-position: right bottom;
  background-size: 11.75rem 2.25rem;
}

.bg1 {
  background: url("/static/img/xy1@3x.png");
  background-repeat: no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;
  font-family: "TXZT";
}

.left-top {
  display: flex;
  justify-content: space-around;

  .left-top-item {
    width: 31%;
    padding: 0 20px;
    overflow: hidden;
  }

  .line-1 {
    background: url("/static/img/bleftt.png");
    background-repeat: no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -o-background-size: cover;
    background-position: center 0;
    height: 2.875rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 1.125rem;
    color: #75e6fe;
    font-size: 0.8125rem;
  }

  .line-2 {
    background: url("/static/img/bleftb.png");
    background-repeat: no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -o-background-size: cover;
    background-position: center 0;
    height: 3.125rem;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    margin-top: 1.125rem;
    color: #75e6fe;
    // font-weight: bold;
    font-size: 1.125rem;
    font-family: TXZT;

    span {
      padding-top: 5px;
    }
  }
}

.box1 {
  width: 2.1875rem;
  height: 2.6875rem;
  background: url("/static/img/szb@3x.png");
  display: flex;
  align-items: center;
  justify-content: center;
}

#middle-bottom {
  table {
    color: #abb8c0;

    td {
      padding: 7px;
    }

    thead {
      td {

        // background-color: #054468;
        div {
          padding: 0.125rem;
        }
      }
    }

    tbody {
      td {
        font-size: 0.875rem;
      }
    }
  }
}

#middle-top {
  width: 100%;
  height: 100%;
}

#middle-top2 {
  width: 94%;
  background: url("/static/img/banner@3x.png");
  background-repeat: no-repeat;
  background-position: 53% 1%;
  background-size: 160%;
}

.el-carousel {
  height: 95%;
  overflow: hidden;

  .el-carousel__container {
    height: 80%;
  }
}

.box {
  display: flex;
  flex-direction: column;
  height: 100%;

  .box-head {
    position: relative;

    .box-title {
      display: flex;
      align-items: center;
      padding: 10px 7px;
      border-bottom: 1px solid #0087f9;

      div {
        color: #00edff;
        margin-left: 0.625rem;
        font-size: 1.25rem;
      }

      .honor-box:hover {
        cursor: pointer;
        color: #00ffbf;
      }
    }
  }

  .box-body {
    flex: 1;
    background-color: rgba(7, 65, 122, 0.2);
  }
}

.box-line-1 {
  position: absolute;
  top: 0;
  left: 0;
  width: 10px;
  height: 10px;
  border-top: 1px solid #44c4ff;
}

.box-line-2 {
  position: absolute;
  top: 0;
  right: 0;
  width: 10px;
  height: 10px;
  border-top: 1px solid #44c4ff;
}

.box-line-3 {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 10px;
  height: 10px;
  border-bottom: 1px solid #44c4ff;
}

.box-line-4 {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 10px;
  height: 10px;
  border-bottom: 1px solid #44c4ff;
}

// 全屏样式的定义
.fullscreen {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  margin: 0 !important;
  z-index: 100;
}

.resize {
  position: absolute;
  right: 20px;
  top: 20px;
  cursor: pointer;
}

.screen-container {
  width: 100%;
  height: 100%;
  padding: 0 20px;
  background: url("/static/img/bg@3x.png");
  background-repeat: no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;
  color: #fff;
  box-sizing: border-box;

  .screen-header {
    margin: 0 auto;
    width: 90%;
    height: 130px;
    background: url("/static/img/head@3x.png");
    background-repeat: no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -o-background-size: cover;
    background-position: center 0;

    .title {
      color: #44c4ff;
      font-size: 2.2rem;
      text-align: center;
      padding-top: 1.5625rem;
      font-weight: bold;
      letter-spacing: 3px;
    }

    .title2 {
      text-align: center;
      color: rgb(35, 255, 252);
      font-size: 14px;
      margin-top: 20px;
      font-family: TXZT;
    }

    .desc {
      text-align: center;
      color: #44c4ff;
      font-size: 1.25rem;
      padding-top: 0.625rem;
    }
  }
}

.screen-body {
  width: 100%;
  height: 100%;
  display: flex;
  margin-top: 10px;

  .screen-left {
    height: 100%;
    width: 27.6%;

    #left-top {
      height: 28%;
      position: relative;
    }

    #left-middle {
      height: 28%;
      margin-top: 10px;
      position: relative;
    }

    #left-bottom {
      height: 28%;
      margin-top: 10px;
      position: relative;
    }
  }

  .screen-middle {
    height: 100%;
    width: 41.5%;
    margin-left: 1.6%;
    margin-right: 1.6%;

    #middle-top {
      width: 100%;
      height: 56%;
      position: relative;
    }

    #middle-bottom {
      margin-top: 25px;
      width: 100%;
      height: 28%;
      position: relative;
    }
  }

  .screen-right {
    height: 100%;
    width: 27.6%;

    #right-top {
      height: 28%;
      position: relative;
    }

    #right-middle {
      height: 24%;
      margin-top: 10px;
      position: relative;
    }

    #right-bottom {
      height: 28%;
      margin-top: 10px;
      position: relative;
    }
  }
}
</style>
<style lang="less" scoped>
.statistic {
  background: url("/static/img/bleftb.png");
  background-repeat: no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;
  height: 3.425rem;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  margin-top: 1.125rem;
  color: #75e6fe;
  // font-weight: bold;
  font-size: 1.125rem;
  font-family: TXZT;
}

.last {
  display: flex;
  flex-direction: column;
  align-items: end;
  font-size: 12px;
  color: #ffb956;
  margin-left: 10px;
  margin-top: -4px
}
</style>
